import React from 'react'
import logo from '../assets/descarga.png'

const Compra = () => {
    return(
        <section>
        <img className="compra" src={logo} alt="" />
        </section>
    )
}
export default Compra